type User = {
  id: string
  email: string | undefined
}

export const getSplitKeyForUser = ({ id, email }: User): string => {
  const allowedDomains = ['poweredbypercent.com', 'goodstack.io']
  if (!email) return id

  return allowedDomains.some((domain) => email.endsWith(domain)) ? email : id
}
